import { SurveyResponse } from './save-response.model';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { plainToClass } from 'class-transformer';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';

import { SurveyInstance } from 'app/entities/surveys/survey-instance.model';

/**
 * Service for entity monitoring tab.
 */
@Injectable()
export class EntitySurveysService {
    entityDetailsUpdated: EventEmitter<EntityIdDetails> = new EventEmitter();
    private entityIdDetails: EntityIdDetails;

    constructor(private requestService: ObservableRequestService) {
        this.entityIdDetails = new EntityIdDetails();
    }

    setEntityIdDetails(entityIdDetails: EntityIdDetails): void {
        this.entityIdDetails = entityIdDetails;
        this.entityDetailsUpdated.emit(this.entityIdDetails);
    }

    getEntityIdDetails(): EntityIdDetails {
        return this.entityIdDetails;
    }

    getSurveyDetails(entityId: number): Observable<any> {
        const surveyDetailsUrl = ConstantsService.SURVEY_DETAIL + '/' + entityId + '/Tab';
        return this.requestService.getRequest(surveyDetailsUrl).map(response => {
            return plainToClass(SurveyInstance, response.arrResult as Object[]);
        });
    };

    saveSurveyResponses(surveyResponses: Array<SurveyResponse>) {
        return this.requestService.putRequest(
            ConstantsService.SURVEY_DETAIL,
            JSON.stringify(surveyResponses),
            this.requestService.getJSONContentType());
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/surveys/entity-surveys.service.ts